var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message_alert none"},[_c('strong',[_vm._v("Atenção !")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" Atenção! Este ambiente é apenas de testes, para que os advogados possam se familiarizar com a ferramenta de inscrição. "),_c('br'),_c('b',[_vm._v("Sua inscrição aqui não será válida.")])])
}]

export { render, staticRenderFns }